import { Component } from '@angular/core';
import { LoaderService } from '@app/services/loader.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  imports: [CommonModule],
  animations: [
    trigger('fadeAnimation', [
      state('void', style({
        opacity: 0.2,
        transform: 'rotate(0deg)',
        backgroundColor: 'white'
      })),
      state('*', style({
        opacity: 1,
        transform: 'rotate(0deg)',
        backgroundColor: 'dark'
      })),
      transition('void <=> *', animate('0.7s cubic-bezier(0.4, 0.0, 1, 1)'))
    ])
  ]
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) { }
}
